"use client"

import { Card, CardContent } from "@/components/ui/card"
import { Quote } from "lucide-react"

// Clientes da TRD Solutions

const clients = [
  {
    name: "EcoRecicla Brasil",
    segment: "Reciclagem de Placas Eletronica",
    testimonial:
      "A TRD Solutions transformou nossa operacao. Aumentamos a eficiencia em 40% e reduzimos erros de rastreamento praticamente a zero.",
    contact: "Carlos Mendes",
    role: "Diretor de Operacoes",
  },
  {
    name: "CataliTech",
    segment: "Reciclagem de Catalisadores",
    testimonial:
      "O sistema de gestao nos permitiu escalar nossa operacao de forma sustentavel. Hoje processamos 3x mais material com a mesma equipe.",
    contact: "Ana Paula Costa",
    role: "CEO",
  },
  {
    name: "GreenTech Residuos",
    segment: "Residuos Eletronicos",
    testimonial:
      "A rastreabilidade completa que o sistema oferece nos ajudou a conquistar certificacoes importantes e novos contratos corporativos.",
    contact: "Roberto Silva",
    role: "Gerente Comercial",
  },
]

export function Clients() {
  return (
    <section className="py-20 bg-primary">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-primary-foreground mb-4 text-balance">
            Conheca Nossos Clientes
          </h2>
          <p className="text-primary-foreground/80 text-lg max-w-2xl mx-auto text-balance">
            Empresas que confiam na TRD Solutions para transformar suas
            operacoes de reciclagem
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {clients.map((client) => (
            <Card
              key={client.name}
              className="bg-primary-foreground/10 border-primary-foreground/20 backdrop-blur-sm"
            >
              <CardContent className="p-6">
                <Quote className="w-8 h-8 text-primary-foreground/60 mb-4" />
                <p className="text-primary-foreground/90 mb-6 leading-relaxed">
                  {`"${client.testimonial}"`}
                </p>
                <div className="border-t border-primary-foreground/20 pt-4">
                  <p className="font-semibold text-primary-foreground">
                    {client.name}
                  </p>
                  <p className="text-sm text-primary-foreground/70 mb-2">
                    {client.segment}
                  </p>
                  <p className="text-sm text-primary-foreground/80">
                    {client.contact} - {client.role}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  )
}
